import type { PopupEmbedSettings, TemplateSettings } from "@aswin.dev/types";
import {
  createDefaultPopupEmbedSettings,
  normalizePopupFrequencySettings,
  normalizePopupTriggersSettings,
} from "@aswin.dev/types";

/** Deep-merge saved `settings.popup` onto defaults so UI always has full shape. */
export function resolvePopupEmbed(
  settings: TemplateSettings,
): PopupEmbedSettings {
  const base = createDefaultPopupEmbedSettings();
  const p = settings.popup;
  if (!p) return base;

  const triggers = normalizePopupTriggersSettings(base.triggers, p.triggers);

  return {
    triggers,
    design: {
      ...base.design,
      ...(p.design ?? {}),
      contentPadding: {
        ...base.design.contentPadding,
        ...(p.design?.contentPadding ?? {}),
      },
    },
    schedule: {
      ...base.schedule,
      ...(p.schedule ?? {}),
      slots:
        p.schedule?.slots !== undefined
          ? p.schedule.slots
          : base.schedule.slots,
    },
    frequency: normalizePopupFrequencySettings(p.frequency),
  };
}
